function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import PropTypes from 'prop-types';
import { SortableList, SortableItem, arrayMove } from './_internal/Sortable';
import Card from '../card/Card';
import { STYLE_PROP_TYPE } from '../card/constants';
import { CARD_ITEMS_PROP_TYPE } from './constants';

var CardList =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(CardList, _React$PureComponent);

  function CardList() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, CardList);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(CardList)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "_handleSortEnd", function (_ref) {
      var oldIndex = _ref.oldIndex,
          newIndex = _ref.newIndex;
      var onSortEnd = _this.props.onSortEnd;

      if (onSortEnd) {
        onSortEnd({
          arrayMove: arrayMove,
          oldIndex: oldIndex,
          newIndex: newIndex
        });
      }
    });

    return _this;
  }

  _createClass(CardList, [{
    key: "_getCardListItems",
    value: function _getCardListItems(items, cardListStyle) {
      return items.map(function (_ref2) {
        var id = _ref2.id,
            content = _ref2.content,
            style = _ref2.style,
            isSelected = _ref2.isSelected;
        return React.createElement("li", {
          className: "eds-card-list__item",
          key: id,
          "data-spec": "eds-card-list-item"
        }, React.createElement(Card, {
          style: style || cardListStyle,
          isSelected: isSelected
        }, content));
      });
    }
  }, {
    key: "_getSortableItems",
    value: function _getSortableItems(items, cardListStyle, dragHandle) {
      return items.map(function (_ref3, index) {
        var id = _ref3.id,
            content = _ref3.content,
            style = _ref3.style,
            isSortable = _ref3.isSortable,
            isSelected = _ref3.isSelected;

        if (isSortable !== false) {
          return React.createElement(SortableItem, {
            key: id,
            index: index,
            content: content,
            style: style || cardListStyle,
            dragHandle: dragHandle,
            isSelected: isSelected
          });
        }

        return React.createElement("li", {
          key: id,
          className: "eds-card-list__item"
        }, React.createElement(Card, {
          style: style || cardListStyle
        }, content));
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          items = _this$props.items,
          style = _this$props.style,
          dragHandle = _this$props.dragHandle,
          onSortEnd = _this$props.onSortEnd;

      if (onSortEnd) {
        return React.createElement(SortableList, {
          items: this._getSortableItems(items, style, dragHandle),
          axis: "y",
          lockAxis: "y",
          useDragHandle: dragHandle !== null,
          lockToContainerEdges: true,
          onSortEnd: this._handleSortEnd,
          helperClass: "eds-card-list__sortable--dragged"
        });
      }

      return React.createElement("ul", {
        className: "eds-card-list"
      }, this._getCardListItems(items, style));
    }
  }]);

  return CardList;
}(React.PureComponent);

_defineProperty(CardList, "propTypes", {
  /**
   * Array of Card items. Each must include a unique id to be
   * used as a key for the list item.
   */
  items: CARD_ITEMS_PROP_TYPE.isRequired,

  /**
   * Changes the style of all the card items.
   * Useful if all cards should have the same style applied
   * and you don't want to specify a style for each one.
   */
  style: STYLE_PROP_TYPE,

  /**
   * Pass this function to make the card list sortable.
   * We call it when sorting is completed with the oldIndex,
   * and newIndex of the dragged item, and a function named arrayMove.
   * Reorder your items by calling arrayMove(items, oldIndex, newIndex)
   * which will in turn re-render the UI in Card List.
   */
  onSortEnd: PropTypes.func,

  /**
   * An element to use as the drag handle for each sortable item.
   * By default a sortable list gets a drag handle.
   * You can also pass in null, to make the entire item draggable.
   * Only applicable if onSortEnd was passed in.
   */
  dragHandle: PropTypes.node
});

export { CardList as default };